/**
 *@file config.js
 *@version 1.0.1
 *@author wuwg
 *@createTime 2019/10/17 - 20:37
 *@updateTime 2019/10/17 - 20:37
 *@see [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 * @description    server-config.js.js ,所有服务器的url配置
 */
const dirServicePath = window.serverConfig.dirServicePath;
const dirCodeServicePath = window.serverConfig.dirCodeServicePath;
// 服务数据
const serverUrl = {
    // 测试模块
    test:{
        // 测试模块首页数据
        index: `${dirServicePath}/rest/index`
    },
    // 专题模块
    zt:{
        index:`${dirServicePath}/api/v2/ww/zt/page`,
        ztMessage:`${dirServicePath}/api/v2/ww/ztlm/{ztid}`,
        ztMessage_hssp:`${dirServicePath}/api/v2/ww/ztlm_hssp/{ztid}`,
        more:`${dirServicePath}/api/v2/ww/ztwz/page`,
        more_hssp:`${dirServicePath}/api/v2/ww/ztwz_hssp/page`,
        xq:`${dirServicePath}/api/v2/ww/ztwz/{id}`,
        xqhssp:`${dirServicePath}/api/v2/ww/ztwzhssp/{id}`
     //   xqhssp:`${dirServicePath}/api/v1/ww/ztwzhssp/{id}`

    },
    szsj: {
        spajtj: `${dirServicePath}/api/v2/spzx/sp/ajlb`,
        hsajtj: `${dirServicePath}/api/v2/spzx/sp/hsfy/ajs`,
        sgattj: `${dirServicePath}/api/v2/spzx/sp/gatsw/ajs`,
        aytj: `${dirServicePath}/api/v2/spzx/sp/ay`,
        zxajtj: `${dirServicePath}/api/v2/spzx/zx/hsfy/zx`,
        zxhstj: `${dirServicePath}/api/v2/spzx/zx/hsfy/zx/aj`,
        zxbdzltj: `${dirServicePath}/api/v2/spzx/zx/bdzl`,
        zxbdjetj: `${dirServicePath}/api/v2/spzx/zx/bdje`,
        swtj:  `${dirServicePath}/api/v2/spzx/sp/sw`
    },
    // 法院介绍模块
    fyjs:{
        hsspgkOrSafw:`${dirServicePath}/api/v2/ww/gjfb/{gjlb}`,
        fyjs:`${dirServicePath}/api/v2/ww/gjfb/fyjs/{fydm}`,
        fglb:`${dirServicePath}/api/v2/ww/gjfb/page`
    },
    // 扣押拍卖模块
    kypm:{
        kypmYl:`${dirServicePath}/api/v2/ww/kypmxx`,
        kypmYlPmfx: `${dirServicePath}/api/v2/ww/kypmxx/pmfx`,
        kyxx:`${dirServicePath}/api/v2/ww/kyxx/page`,
        pmxx:`${dirServicePath}/api/v2/ww/pmxx/page`,
        pmfx:`${dirServicePath}/api/v2/ww/pmfx`,
        pmxq:`${dirServicePath}/api/v2/ww/pmxx/{id}`,
        kyxq:`${dirServicePath}/api/v2/ww/kyxx/{id}`
    },
    Hsal:{
        // 域外司法的页面搜索
        hsalindex: `${dirServicePath}/api/v1/sfal/sfalyl/{id}`,
        HsalpageOut: `${dirServicePath}/api/v1/hsalb/Hsalpage/out`,
        HsalDataile: `${dirServicePath}/api/v2/ww/hsalb/{id}`,
        hsalb:`${dirServicePath}/api/v2/ww/hsalb/page`,
        fbdwList:`${dirServicePath}/api/v2/ww/fbdwList`
    },
    Hsss: {
        hsslList: `${dirServicePath}/api/v2/ww/gjfb/hsss`,
        hsslMore:  `${dirServicePath}/api/v2/ww/gjfb/hsss/more/page`
    },
    // 首页模块
    home:{
        latestXxxsd: `${dirServicePath}/api/v2/home/latestXxxsd`,
        latestNews: `${dirServicePath}/api/v2/home/latestNews`,
        latestFygg: `${dirServicePath}/api/v2/home/latestFygg`,
        latestKyxx: `${dirServicePath}/api/v2/home/latestKyxx`,
        latestCbpm: `${dirServicePath}/api/v2/home/latestCbpm`,
        latestHsal: `${dirServicePath}/api/v2/home/latestHsal`,
        latestLltt: `${dirServicePath}/api/v2/home/latestLltt`,
        latestSptb: `${dirServicePath}/api/v2/home/latestSptb`,
        latestSfwj: `${dirServicePath}/api/v2/home/latestSfwj`,
        latestYwsf: `${dirServicePath}/api/v2/home/latestYwsf`,
        latestHszc: `${dirServicePath}/api/v2/home/latestHszc`,
        latestZtxx: `${dirServicePath}/api/v2/home/latestZtxx`,
        latestBswwsqd: `${dirServicePath}/api/v2/home/latestBswwsqd`,
        latestJpcpws: `${dirServicePath}/api/v2/home/latestJpcpws`
    },
    xwzx: {
        latestXwzx: `${dirServicePath}/api/v2/home/latestXwzx`,
        latestXwzxPage: `${dirServicePath}/api/v2/home/latestXwzx/page`,
        selectById: `${dirServicePath}/api/v2/home/latestXwzx/{id}`

    },
    common: {
        getFile: `${dirCodeServicePath}/api/v1/files`,
        downloadFile: `${dirCodeServicePath}/api/v1/files/{id}/actions/download`,
        searchByKeyword: `${dirServicePath}/api/v2/search/byParam`
    },
    szsjtj: {
        countForSpajtj: `${dirServicePath}/api/v2/hsajtj/spajtj`,
        countForZxajtj: `${dirServicePath}/api/v2/hsajtj/zxajtj`,
        selectSjtjSwgatajForSw: `${dirServicePath}/api/v2/hsajtj/swajtj`,
        selectSjtjSwgatajForGAT: `${dirServicePath}/api/v2/hsajtj/sgqtajtj`,
        countForSpajtjHsfysj: `${dirServicePath}/api/v2/hsajtj/spajtj/hsfysj`
    }
};
export default serverUrl;
